export function formatNumberWithDigits(value: number | string): string {
  const numericValue = Number(value);
  if (isNaN(numericValue)) return "";
  return numericValue.toLocaleString("ru-RU");
}
